export const xSymbolUnicode = "\u{1f7aa}";

export function stringToBoolean(s: string | undefined) {
	if (s === undefined) return undefined;
	if (s.toLowerCase() === "true") return true;
	if (s.toLowerCase() === "false") return false;
	return undefined;
}

export function startsWithNumber(s: string) {
	return /^\d/.test(s);
}

export function isNullOrWhiteSpace(s: string | undefined | null) {
	return s == null || s.replace(/\s/g, "").length < 1;
}

export function jsonSyntaxHighlight(json: string) {
	json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
	return json.replace(
		/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
		function (match) {
			let cls = "number";
			if (/^"/.test(match)) {
				if (/:$/.test(match)) {
					cls = "key";
				} else {
					cls = "string";
				}
			} else if (/true|false/.test(match)) {
				cls = "boolean";
			} else if (/null/.test(match)) {
				cls = "null";
			}
			return '<span class="' + cls + '">' + match + "</span>";
		}
	);
}

export function scrollToTop() {
	window.scroll({
		top: 0,
		left: 0,
		behavior: "smooth",
	});
}

export function toOrdinal(value: number): string {
	if (value % 100 > 10 && value % 100 < 20) return `${value}th`;

	switch (value % 10) {
		case 1:
			return `${value}st`;
		case 2:
			return `${value}nd`;
		case 3:
			return `${value}rd`;
		default:
			return `${value}th`;
	}
}

export const countWords = (s: string) => {
	if (!s || s === "No Essay Entered") {
		return 0;
	}

	const count = (s.replace(/['";:,.?¿\-!¡]+/g, "").match(/\S+/g) || []).length;
	return count;
};

export function integerName(i: number): string {
	const ints = [
		"zero",
		"one",
		"two",
		"three",
		"four",
		"five",
		"six",
		"seven",
		"eight",
		"nine",
		"ten",
		"eleven",
		"twelve",
		"thirteen",
		"fourteen",
		"fifteen",
		"sixteen",
		"seventeen",
		"eighteen",
		"nineteen",
		"twenty",
	];
	if (!Number.isInteger(i)) return i.toLocaleString();
	if (0 <= i && i < ints.length) return ints[i];
	return i.toLocaleString();
}

export const zeroPad = (num: number, places: number) => String(num).padStart(places, "0");

export function getParamAsInt(queryParams: URLSearchParams, param: string): number | undefined {
	const _p = parseInt(queryParams.get(param) ?? "");
	return isNaN(_p) ? undefined : _p;
}

export const isString = (value: any) => typeof value === "string" || value instanceof String;

export function htmlDecode(input: string) {
	var doc = new DOMParser().parseFromString(input, "text/html");
	return doc.documentElement.textContent;
}

export const capitalize = (s: any) => s && String(s[0]).toUpperCase() + String(s).slice(1);

export function isEmpty(obj: Object): boolean {
	return Object.keys(obj).length === 0;
}
